import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
/* context */
import { AuthContext } from "./context";
/* hooks */
import CurrencyProvider from "./hooks/CurrencyProvider";
import TripProvider from "./hooks/TripProvider";
/* pages */
import { MainPage } from "./pages/MainPage";
/* api */
import ApiCall from "./api/network";
/* routes */
import { WebRoutes } from "./routes/WebRoutesPath";
import {GlobalDebug} from "./utils/remove-consoles";

const App = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState({});
  const [webSettings, setWebSettings] = useState({});
  const [notVerified, setNonVerified] = useState(false);

  const verifyDomain = async (domain) => {
    const verifyDomain = {
      method: "GET",
      url: `/checkDomain/${domain}`,
      useAuth: false,
    };

    const response = await ApiCall.any(verifyDomain, {});

    if (response === -1) {
      setNonVerified(true);
      return navigate(WebRoutes.WebNotFound);
    }
  };

  useEffect(() => {
    Aos.init({ offset: 20 });
    //  eslint-disable-next-line
    const domain = /:\/\/([^\/]+)/.exec(window.location.href)[1];
    if (domain !== "members.tripmerchant.com") {
      let subDomain = domain.split(".");
      subDomain = subDomain[0] === "www" ? subDomain[1] : subDomain[0];
      if (
        subDomain &&
        subDomain !== "tripmerchant" &&
        subDomain !== "localhost:3001" && 
        subDomain !== "tripbuilder"
      ) {
        verifyDomain(subDomain);
      }
    }
    //  eslint-disable-next-line
  }, []);

  /**
   * @REMOVE_CONSOLES
   * // remove the working of console logs
   * // remove any accidental use of console logs
   */
  useEffect(() => {
    (process.env.NODE_ENV === "production" ||
        process.env.REACT_APP_ENV === "STAGING") &&
    GlobalDebug(false);
  }, []);

  console.log("I am just another dummy console log,suppose to be suppressed 🙂");

  return (
    <AuthContext.Provider
      value={{
        token,
        setToken,
        currentUser,
        setCurrentUser,
        webSettings,
        setWebSettings,
        notVerified,
      }}
    >
      <CurrencyProvider>
        <TripProvider>
          <MainPage notVerified={notVerified} />
        </TripProvider>
      </CurrencyProvider>
    </AuthContext.Provider>
  );
};

export default App;
